<template>
  <div>

    <!-- 添加按钮 -->
    <el-button @click="add" type="primary" class="addBtn">添加用户</el-button>

    <!-- 列表 -->
    <el-table v-loading="loading" element-loading-text="拼命加载中" stripe :data="tableData">
      <el-table-column label="管理员名称" prop="username">
      </el-table-column>
      <el-table-column label="状态" prop="status">
      </el-table-column>
      <el-table-column label="APP名称" prop="app.name">
      </el-table-column>
      <el-table-column label="创建时间" prop="createdAt">
      </el-table-column>
      <el-table-column label="操作">
        <template scope="scope">
          <el-button size="small" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
     <Page :way="ways" @pageNum='pageNum' @pageOne='pageOne'></Page>  

    <!-- 弹框 编辑 -->
    <el-dialog title="管理员操作" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="管理员名称" :label-width="formLabelWidth">
          <el-input v-model="form.username" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="form.password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="app名称" :label-width="formLabelWidth">
          <el-select v-model="form.appId" placeholder="app">
            <el-option v-for="(item, index) in list" :label="item.name" :key="index" :value="item.objectId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户状态" :label-width="formLabelWidth">
          <el-select v-model="form.status" placeholder="用户状态">
            <el-option label="正常" value="normal"></el-option>
            <el-option label="禁用" value="disabled"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editOpt" v-if="editLoad">编 辑</el-button>
        <el-button type="primary" @click="addOpt" v-if="addLoad">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import util from '../../util/util';
import Page from '../../components/Page.vue'

export default {
   components: {
    Page
  },
  data() {
    return {
      tableData: [],
      loading: true,
      form: {
        username: '',
        status: '',
        appId: ''
      },
      editLoad: false,
      addLoad: false,
      dialogFormVisible: false,
      eidtData: {},
      formLabelWidth: '120px',
      list: [],
      ways: '/users' ,
      limit: util.limit,
      skip: util.skip,
    }
  },
  methods: {
    pageNum(msg){
      this.limit = msg ;
      this.getData();
    },
    pageOne(msg){
      this.skip = msg -1 ;
      this.getData();
    },
    getData() {
      axios.get('/users', {
        params: {
          limit:this.limit,
          skip: this.skip * this.limit ,
          order: '-createdAt',
          where: {
            type: 'app'
          }
        }
      }).then((response) => {
        this.tableData = response.data;
        console.log(this.tableData)
        this.tableData.filter(item=>{
          item.createdAt=util.dateForm(item.createdAt);
          item.status = (item.status == 'normal' ? '正常' : '禁用' );
        })
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      })
    },
    getApp() {
      axios.get('/apps').then((response) => {
        this.list = response.data;
      })
    },
    add() {
      this.dialogFormVisible = true;
      this.editLoad = false;
      this.addLoad = true;
      this.form = {
        username: '',
        status: '',
        appId: '',
        password: ''
      }
      this.getApp();
    },
    edit(row) {
      this.getApp();
      this.dialogFormVisible = true;
      this.editData = row;
      this.editLoad = true;
      this.addLoad = false;
      this.form.username = row.username;
      this.form.status = row.status;
      row.app ? this.form.appId = row.app.objectId : this.form.appId = '';
    },
    editOpt() {
      this.dialogFormVisible = false;
      let obj = {
        status: this.form.status == '禁用' || this.form.status=='disabled' ? 'disabled' : 'normal',
        password: this.form.password,
        app: {
          __type: 'Pointer',
          className: 'App',
          objectId: this.form.appId
        }
      }
      console.log(this.form.status)
      this.form.username == this.editData.username ? obj : obj.username = this.form.username;
      axios.put('/users/' + this.editData.objectId, obj).then((response) => {
        this.getData();
      })
    },
    addOpt() {
      this.dialogFormVisible = false;
      axios.post('/users', {
        username: this.form.username,
        password: this.form.password,
        status: this.form.status,
        app: {
          __type: 'Pointer',
          className: 'App',
          objectId: this.form.appId
        }
      }).then((response) => {
        this.getData();
      })
    }

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.addBtn {
  @include floatBtn
}
</style>



// WEBPACK FOOTER //
// src/views/user/User.vue?671971b2